import React, { FC } from 'react'
import { Flex } from '../..'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDrag: FC<IconSVGProps> = ({ ...props }) => (
  <Flex align="center" justify="center">
    <IconSVG className="IconDrag" {...props}>
      <svg height="100%" width="28" viewBox="0 0 28 8" fill="currentColor">
        <path d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H27C27.5523 2 28 1.55228 28 1C28 0.447715 27.5523 0 27 0H1Z" />
        <path d="M1 6C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8H27C27.5523 8 28 7.55228 28 7C28 6.44772 27.5523 6 27 6H1Z" />
      </svg>
    </IconSVG>
  </Flex>
)

export default IconDrag
